import scenarioImages from '../scenarioImages'

export default {
  slug: 'ib11',
  title: 'IB11',
  i18nKey: 'AutomotiveImuProducts.ib11',
  heroTitleSize: 'large',
  images: {
    hero: require('@/assets/images/pixso-automotive-detail/ib11-hero.png'),
    description: require('@/assets/images/pixso-automotive-detail/ib11-description.png'),
    feature: require('@/assets/images/pixso-automotive-detail/ib11-feature.png')
  },
  descriptionTags: [
    { key: 'arrayIMU', image: require('@/assets/images/pixso-automotive-detail/icon-arrayimu.svg') },
    { key: 'accelerometer', image: require('@/assets/images/pixso-automotive-detail/icon-accelerometer.svg') },
    { key: 'gyroscope', image: require('@/assets/images/pixso-automotive-detail/icon-gyro.svg') }
  ],
  featureTags: [
    { key: 'lowPower', image: require('@/assets/images/pixso-automotive-detail/icon-low-power.svg') },
    { key: 'performance', image: require('@/assets/images/pixso-automotive-detail/icon-performance.svg') },
    { key: 'fullTemperature', image: require('@/assets/images/pixso-automotive-detail/icon-calibration.svg') },
    { key: 'environment', image: require('@/assets/images/pixso-automotive-detail/icon-environment.svg') }
  ],
  scenarios: [
    {
      key: 'tunnelFork',
      image: scenarioImages.tunnelFork
    },
    {
      key: 'parking',
      image: scenarioImages.parking
    },
    {
      key: 'overpass',
      image: scenarioImages.overpass
    },
    {
      key: 'urbanCanyon',
      image: scenarioImages.urbanCanyon
    },
    {
      key: 'complexTraffic',
      image: scenarioImages.complexTraffic
    },
    {
      key: 'treeLinedStreet',
      image: scenarioImages.treeLinedStreet
    }
  ],
  specTabs: [
    {
      labelKey: 'AutomotiveImuProducts.ib11.tabs.gyro',
      rows: [
        { labelKey: 'ProductSpecs.rows.量程', value: { valueKey: 'AutomotiveImuProducts.ib11.specValues.gyro.range' } },
        { labelKey: 'ProductSpecs.rows.零偏稳定性（10s平滑）', value: { valueKey: 'AutomotiveImuProducts.ib11.specValues.gyro.biasStability' } },
        { labelKey: 'ProductSpecs.rows.零偏不稳定性（Alan方差）', value: { valueKey: 'AutomotiveImuProducts.ib11.specValues.gyro.biasInstability' } },
        { labelKey: 'ProductSpecs.rows.全温零偏（10s平滑）', value: { valueKey: 'AutomotiveImuProducts.ib11.specValues.gyro.fullTempBias' } },
        { labelKey: 'ProductSpecs.rows.标度因数误差', value: { valueKey: 'AutomotiveImuProducts.ib11.specValues.gyro.scaleError' } },
        { labelKey: 'ProductSpecs.rows.交叉耦合', value: { valueKey: 'AutomotiveImuProducts.ib11.specValues.gyro.crossCoupling' } },
        { labelKey: 'ProductSpecs.rows.角度随机游走', value: { valueKey: 'AutomotiveImuProducts.ib11.specValues.gyro.angleRandomWalk' } },
        { labelKey: 'ProductSpecs.rows.-3db带宽', value: { valueKey: 'AutomotiveImuProducts.ib11.specValues.gyro.bandwidth' } },
        { labelKey: 'ProductSpecs.rows.工作频率', value: { valueKey: 'AutomotiveImuProducts.ib11.specValues.gyro.operatingFrequency' } }
      ]
    },
    {
      labelKey: 'AutomotiveImuProducts.ib11.tabs.accelerometer',
      rows: [
        { labelKey: 'ProductSpecs.rows.量程', value: { valueKey: 'AutomotiveImuProducts.ib11.specValues.accelerometer.range' } },
        { labelKey: 'ProductSpecs.rows.零偏稳定性（10s平滑）', value: { valueKey: 'AutomotiveImuProducts.ib11.specValues.accelerometer.biasStability' } },
        { labelKey: 'ProductSpecs.rows.零偏不稳定性（Alan方差）', value: { valueKey: 'AutomotiveImuProducts.ib11.specValues.accelerometer.biasInstability' } },
        { labelKey: 'ProductSpecs.rows.全温零偏（10s平滑）', value: { valueKey: 'AutomotiveImuProducts.ib11.specValues.accelerometer.fullTempBias' } },
        { labelKey: 'ProductSpecs.rows.标度因数误差', value: { valueKey: 'AutomotiveImuProducts.ib11.specValues.accelerometer.scaleError' } },
        { labelKey: 'ProductSpecs.rows.交叉耦合', value: { valueKey: 'AutomotiveImuProducts.ib11.specValues.accelerometer.crossCoupling' } },
        { labelKey: 'ProductSpecs.rows.速度随机游走', value: { valueKey: 'AutomotiveImuProducts.ib11.specValues.accelerometer.velocityRandomWalk' } },
        { labelKey: 'ProductSpecs.rows.-3db带宽', value: { valueKey: 'AutomotiveImuProducts.ib11.specValues.accelerometer.bandwidth' } },
        { labelKey: 'ProductSpecs.rows.工作频率', value: { valueKey: 'AutomotiveImuProducts.ib11.specValues.accelerometer.operatingFrequency' } }
      ]
    },
    {
      labelKey: 'ProductSpecs.tabs.physicalAndElectrical',
      rows: [
        { labelKey: 'ProductSpecs.rows.尺寸', value: { valueKey: 'AutomotiveImuProducts.ib11.specValues.physical.dimensions' } },
        { labelKey: 'ProductSpecs.rows.通讯接口', value: { valueKey: 'AutomotiveImuProducts.ib11.specValues.physical.communicationInterface' } },
        { labelKey: 'ProductSpecs.rows.供电电压', value: { valueKey: 'AutomotiveImuProducts.ib11.specValues.physical.supplyVoltage' } },
        { labelKey: 'ProductSpecs.rows.功耗', value: { valueKey: 'AutomotiveImuProducts.ib11.specValues.physical.powerConsumption' } }
      ]
    },
    {
      labelKey: 'ProductSpecs.tabs.environmentParams',
      rows: [
        { labelKey: 'ProductSpecs.rows.工作温度', value: { valueKey: 'AutomotiveImuProducts.ib11.specValues.environment.operatingTemperature' } },
        { labelKey: 'ProductSpecs.rows.存储温度', value: { valueKey: 'AutomotiveImuProducts.ib11.specValues.environment.storageTemperature' } }
      ]
    }
  ]
}
